
// Mutations
export const BINDPROPERTIES = 'BINDPROPERTIES'
export const UNBINDPROPERTIES = 'UNBINDPROPERTIES'

export const RESETPROPERTIES = 'RESETPROPERTIES'

// Actions
export const ADDPROPERTY = 'ADDPROPERTY';
export const EDITPROPERTY = 'EDITPROPERTY';
export const DELETEPROPERTY = 'DELETEPROPERTY';
export const MOVEPROPERTYBEFORE = 'MOVEPROPERTYBEFORE';


import db from '../../firebase/firebase'
import { bindArrayWithBuffering } from '../helpers/binding';
import { generateUpdatesForObject } from '../helpers/updates'
import { compareSortOrder, snapshots2objects } from '../helpers/general'

export default {
  state: () => ({
    sortorder: '',
    properties: [],
  }),

  getters: {
  },

  mutations: {
    addBoundPropertyBatch: ( state, arrayOfSnapshots ) => {
      const arrayOfObjects = snapshots2objects( arrayOfSnapshots )

      let newproperties = state.properties.concat( arrayOfObjects )
      state.properties = sortPropsByOrder( newproperties, state.sortorder )
    },
    removeBoundPropertyBatch: ( state, arrayOfSnapshots ) => {
      const keysToRemove = arrayOfSnapshots.map( snapshot => { return snapshot.key })
      state.properties = state.properties
                              .filter( s => !keysToRemove.includes( s['.key'] ) )
    },
    updateBoundPropertyBatch: ( state, arrayOfSnapshots ) => {
      const arrayOfObjects = snapshots2objects( arrayOfSnapshots )

      let newproperties = state.properties
                               .filter( s => !arrayOfObjects.find( obj => obj['.key'] == s['.key'] ) )
                               .concat( arrayOfObjects )
      state.properties = sortPropsByOrder( newproperties, state.sortorder)
    },

    setPropertiesSortOrder( state, { sortorder } ) {
      state.sortorder = sortorder

      state.properties = sortPropsByOrder( state.properties, sortorder )
    },

    [RESETPROPERTIES] ( state ) {
      state.sortorder = ''
      state.properties = []
    },
  },

  actions: {
    async [BINDPROPERTIES] ( { commit }, guild ) {
      // Sort Order
      await db.ref( 'guildProperties/' + guild['.key'] + '/sortorder' ).on( 'value',
        ( snapshot ) => commit( 'setPropertiesSortOrder', { sortorder: snapshot.val() } ),
        ( error ) => console.error( 'Properties sort order error', error ) )      

      // Properties
      const propsRef = db.ref( 'guildProperties/' +
                               guild['.key'] + '/properties' )
      return bindArrayWithBuffering( propsRef, commit, 'Property')
    },
    [UNBINDPROPERTIES] ( { rootState } ) {
      let guild = rootState.guilds.selectedGuild
      if( guild ) {
        db.ref( 'guildProperties/' + guild['.key'] + '/properties' ).off()
        db.ref( 'guildProperties/' + guild['.key'] + '/sortorder' ).off()
      }
    },
    
    async [ADDPROPERTY] ( { state }, { guild, property } ) {
      if( guild ) {
        let ref = await db.ref( 'guildProperties/' + guild['.key'] + '/properties' ).push( property )

        let sortStr = ''
        for( let prop of state.properties ) {
          sortStr += prop['.key'] + ';'
        }
        if( sortStr.search( ref.key + ';' ) == -1 ) sortStr += ref.key + ';'
        
        db.ref( 'guildProperties/' + guild['.key']
                + '/sortorder').set( sortStr )
      }
    },
    [EDITPROPERTY] ( context, { guild, property, newvalues } ) {
      if( guild && property ) {
        let updates = generateUpdatesForObject(
          'guildProperties/' + guild['.key'] +
          '/properties/' + property['.key'] + '/', newvalues )
        return db.ref().update( updates )
      }
    },
    [DELETEPROPERTY] ( { state, rootState }, { guild, property } ) {
      
      if( guild && property ) {

        let updates = {}

        // Remove the property from all the propreqsets
        for( let propreqset of rootState.propreqsets.propreqsets ) {
          updates[ 'guildPropReqSets/' + guild['.key'] +
                   '/propreqsets/' + propreqset['.key'] +
                   '/' + property['.key'] ] = null
        }

        // Remove the property from all charprops
        if( property.ischarspecific ) {
          let charprops = rootState.charprops.charprops
          for( let playerid in charprops ) {
            for( let charclass in charprops[ playerid ] ) {
              for( let propertyKey in charprops[ playerid ][ charclass ]) {
                if( propertyKey == property['.key'] ) {
                  updates[ 'guildCharProperties/' + guild['.key']
                           + '/' + playerid
                           + '/' + charclass
                           + '/' + propertyKey ] = null
                }
              }
            }
          }
        }
        else { // player specific prop
          let playerprops = rootState.playerprops.playerprops
          for( let playerid in playerprops ) {
            for( let propertyKey in playerprops[ playerid ] ) {
              if( propertyKey == property['.key'] ) {
                updates[ 'guildPlayerProperties/' + guild['.key']
                          + '/' + playerid
                          + '/' + propertyKey ] = null
              }
            }
          }
        }

        // Delete the property itself
        updates[ 'guildProperties/' + guild['.key' ]
                 + '/properties/' + property['.key'] ] = null
        // Fix the sorting order
        let newsortorder = state.sortorder.replace( property['.key'] + ';', '')
        updates[ 'guildProperties/' + guild['.key'] 
                 + '/sortorder' ] = newsortorder

        return db.ref().update( updates )
      }
    },
    [MOVEPROPERTYBEFORE] ( { state }, { guild, sourcepropertykey, targetpropertykey } ) {
      if( guild && sourcepropertykey && targetpropertykey ) {
        let newsortorder = state.sortorder
                                // Remove the source key from the string
                                .replace( sourcepropertykey + ';', '' )
                                // Insert it in front of the target key
                                .replace( targetpropertykey + ';',
                                          sourcepropertykey + ';'
                                          + targetpropertykey + ';' )
        let sortOrderRef = 'guildProperties/' + guild['.key'] + '/sortorder'
        return db.ref( sortOrderRef ).set( newsortorder );
      }
    },

  },
}

function sortPropsByOrder( properties, sortorder ) {
  let sortedpropKeys = []
  if( sortorder ) sortedpropKeys = sortorder.split( ';' )

  // For each property, find its position in the sortorder array
  for( let prop of properties ) {
    
    let index = sortedpropKeys.findIndex( key => key == prop['.key'] )
    if( index == -1 ) index = 99999999

    prop.sortorder = index
  }

  return properties.sort( compareSortOrder )
}
